import { useSelector } from 'react-redux';
import {
  formatTypeOfCover,
  refactorCoverIsFor,
  sanitizedUtmData,
} from '../../utils/helpers';
import { CoverIsFor } from '../../types/types';
import { getUtmInfo } from '../../utils/form/getUtmInfo';

export const useLeadsObject = () => {
  const { formData, salesReqBody, utmData } = useSelector(
    (state: any) => state.formRegistration,
  );

  const hospitalBenefits = formData.selectedHospitalBenefits.map(
    (benefit_id: any) => ({ id: benefit_id }),
  );

  const extraBenefits = formData.selectedExtrasBenefits.map(
    (benefit_id: any) => ({ id: benefit_id }),
  );

  return {
    general_details: {
      customer_type: refactorCoverIsFor(formData.coverIsFor),
      product_type: formatTypeOfCover(formData.typeOfCover),
      hospital_benefits: hospitalBenefits,
      extras_benefits: extraBenefits,
    },
    customer: {
      first_name: salesReqBody.customer.first_name,
      ...(salesReqBody.customer.last_name && {
        last_name: salesReqBody.customer.last_name,
      }),
      dob: formData.dateOfBirth?.[0]
        .replaceAll('/', '-')
        .split('-')
        .reverse()
        .join('-'),
      continuous_cover: formData?.hadContinuousCover ?? false,
      email: salesReqBody?.customer?.email || '',
      ...(salesReqBody.customer.phone && {
        phone: salesReqBody.customer.phone,
      }),
      ...(salesReqBody.customer.mobile && {
        mobile: salesReqBody.customer.mobile,
      }),
      previous_fund_code: formData.healthFundCode,
      is_receive_marketing: 1,
    },
    ...(formData.coverIsFor === CoverIsFor.Couple ||
    formData.coverIsFor === CoverIsFor.Family
      ? {
          partner: {
            dob: formData.dateOfBirth?.[1]
              .replaceAll('/', '-')
              .split('-')
              .reverse()
              .join('-'),
            continuous_cover: formData?.hadContinuousCoverPartner ?? false,
          },
        }
      : {}),
    ...(formData.coverIsFor === CoverIsFor.Family ||
    formData.coverIsFor === CoverIsFor.SingleParentFamily
      ? {
          dependants: salesReqBody.dependants.map((dependant: any) => ({
            age: dependant.age,
            education_details: {
              full_time: dependant.education_details.full_time,
            },
          })),
        }
      : {}),
    residential_address: {
      state: formData.state || 1,
    },
    government_rebate: {
      // tier index 4 is no government rebate it is the same as 3, 0% rebate
      income_tier: formData.tierIndex === 4 ? 3 : formData.tierIndex,
    },
    marketing: {
      ...sanitizedUtmData(getUtmInfo()),
      ip_address: utmData?.ip_address || '',
    }, // Use sanitized marketing data
  };
};
